import { datadogRum } from '@datadog/browser-rum';

/**
 * Initialize Datadog RUM (Real User Monitoring)
 * Monitors frontend performance, errors, and user sessions
 *
 * Uses shared P7S1 Datadog application across all joyia services.
 * Service differentiation happens via the 'service' tag.
 */
export function initDatadog() {
  const applicationId = import.meta.env.VITE_DATADOG_RUM_APPLICATION_ID;
  const clientToken = import.meta.env.VITE_DATADOG_RUM_CLIENT_TOKEN;
  const env = import.meta.env.VITE_DATADOG_ENV || 'dev';
  // UST version, supplied by infra alongside env. Without it every RUM session reported no
  // version, so a regression could not be tied to a deploy.
  const version = import.meta.env.VITE_DATADOG_VERSION;

  // Skip Datadog in local development (dev server running on localhost)
  if (typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  )) {
    console.log('Datadog RUM disabled in local development');
    return;
  }

  // Only initialize if credentials are available (controlled by infra/chat.ts)
  if (!applicationId || !clientToken) {
    console.log('Datadog RUM disabled (no credentials provided)');
    return;
  }

  try {
    datadogRum.init({
      applicationId,
      clientToken,
      site: 'datadoghq.eu',
      service: 'joyia-file-viewer', // Service tag for filtering in Datadog
      env,
      ...(version ? { version } : {}),
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackBfcacheViews: true,
      defaultPrivacyLevel: 'mask-user-input',
    });

    console.log('Datadog RUM initialized for joyia-file-viewer');
  } catch (error) {
    console.error('Failed to initialize Datadog RUM:', error);
  }
}
